import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class Container extends Component {
	getClass() {
		const { fluid } = this.props;
		return `container${fluid ? '-fluid' : ''}`;
	}

	render() {
		const { children } = this.props;
		return (
			<div className={this.getClass()}> {children} </div>
		)
	}
}

Container.propTypes = {
	fluid: PropTypes.bool,
	children: PropTypes.object
}

export class Row extends Component {
	render() {
		const { children, style, className } = this.props;
		let classes = 'row ';
		if (className) classes += className

		return (
			<div className={classes} style={style}> {children} </div>
		)
	}
}

Row.propTypes = {
	children: PropTypes.any
}

export class Col extends Component {
	getClasses() {
		let classes = '';
		const upper = (str) => str.charAt(0).toUpperCase() + str.slice(1);

		['xs', 'sm', 'md', 'lg'].forEach((size) => {
			if (this.props[size]) classes += `col-${size}-${this.props[size]} `;

			['offset', 'push', 'pull'].forEach((type) => {
				const key = type + upper(size);
				if (this.props[key]) classes += `col-${size}-${type}-${this.props[key]} `;
			});
		});
		if (this.props.className) classes += this.props.className
		return classes;
	}

	render() {
		const { children, style, id } = this.props;
		return (
			id === undefined ?
			<div className={this.getClasses()} style={style}> {children} </div> :
			<div className={this.getClasses()} style={style} id={id}> {children} </div>
		)
	}
}

Col.propTypes = {
	children: PropTypes.any
}

export class FullRow extends Component {
	render() {
		const { children, style, className } = this.props;

		return (
			<Row style={style} className={className}><Col xs="12" sm="12" md="12" lg="12"> {children} </Col> </Row>
		)
	}
}

FullRow.propTypes = {
	children: PropTypes.any
}



// WEBPACK FOOTER //
// ./src/components/framework/Grid/index.js